import { getPopupDispatchers } from "@app/dev/contexts/popup";

export const openDeferModal = async (key, props, closeAfterResolve = true, options = {}) => {
  const { openPopup, closePopup } = getPopupDispatchers();
  const defer = { resolve: () => {} };
  const promise = new Promise((res) => {
    defer.resolve = res;
  });
  openPopup(key, { defer, ...props }, options);

  const result = await promise;

  closeAfterResolve && closePopup();

  return result;
};
